var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 5.41421L18.1213 7.53553L16.3536 9.3033L14.2322 7.18198L16 5.41421ZM12.818 7.18198L13.5251 6.47487L15.2929 4.70711L16 4L16.7071 4.70711L18.8284 6.82843L19.5355 7.53553L18.8284 8.24264L17.0607 10.0104L16.3536 10.7175L10.3431 16.7279L6.83096 17.5384L5.74695 17.7886L5.99711 16.7046L6.80761 13.1924L12.818 7.18198ZM15.6464 10.0104L9.83883 15.818L7.08112 16.4544L7.71751 13.6967L13.5251 7.88909L15.6464 10.0104Z",
    fill: "#181818"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.312a3b6e60021fbeed7b1a8c097d749d.svg";
export { ForwardRef as ReactComponent };